import { apiCommonConfig } from './apiCommon.config';
import type { ApiConfig } from './apiConfigTypes';
import { apiStageConfig } from './apiStage.config';

export const apiProdConfig: ApiConfig = {
  ...apiCommonConfig,
  ...apiStageConfig,

  bifrostBaseUrl: 'https://prod-bifrost-api.foxplus.com',
  entitlementBaseUrl: 'https://ent.fox.com',
  productBaseUrl: 'https://api.fox.com/dtc', // CDN host name
  // productBaseUrl: 'https://prod1-ue1-connect-fn.api.fox.com', // API Gateway path
};
